import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../store/global-selectors';
import { cancelShipmentRequest } from '../../../../store/ltl/ltl.actions';
import { freightActionButtonMessages } from './messages';

import style from '../../../../components/grid-header/shared-classes.module.less';

export const CancelFreightButton = () => {
  const dispatch = useDispatch();
  const selectedShipmentIds = useSelector(Global.selectLtlGridSelectedShipmentIds) ?? emptyArray;

  const handleClick = useCallback(() => {
    if (!selectedShipmentIds.length) return;
    dispatch(cancelShipmentRequest(selectedShipmentIds.map(Number)));
  }, [dispatch, selectedShipmentIds]);

  return (
    <Button className={style['action-button']} disabled={selectedShipmentIds.length === 0} onClick={handleClick} theme='tertiary'>
      <FormattedMessage {...freightActionButtonMessages.cancelFreight} />
    </Button>
  );
};
